import SystemConst from '@/shared/system-const';
import axios from 'axios';

export default {
    namespaced: true,

    actions: {
        // 各アップロードファイルの最大サイズ, 拡張子の取得API
        async getParameters() {
            // 通信結果の初期化
            let result: any;

            // ファイルバリデーション情報を取得
            // URL:GET /api/notification-data/parameters
            // params: なし
            await axios.get('/api/notification-data/parameters')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // パスワード情報ファイル、宛名ファイル、雛形ファイルアップロードAPI
        async notificationFileUpload({ state, commit, rootState }: any, data: any) {
            // 通信結果の初期化
            let result: any;

            // 画面に追加した各ファイル保存用変数
            const forms = new FormData();

            // パスワード情報ファイルをformsに追加
            data.passwordFile.forEach((e: any) => {
                if (e instanceof File) {
                    forms.append('passwordFile', e, e.name);
                }
            });

            // 宛名ファイルをformsに追加
            data.addresseeFile.forEach((e: any) => {
                if (e instanceof File) {
                    forms.append('addresseeFile', e, e.name);
                }
            });

            // 雛形ファイルをformsに追加
            data.templateFile.forEach((e: any) => {
                if (e instanceof File) {
                    forms.append('templateFile', e, e.name);
                }
            });

            // ファイルアップロード
            // URL:POST /api/notification-data/file-upload
            await axios.post('/api/notification-data/file-upload', forms)
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 通知データ作成API
        async createNotificationData({ state, commit, rootState }: any) {
            // resultの初期化
            let result: any;

            // back側で通知データを作成
            // 通信：post
            // パス：/api/notification-data/create-notification-data
            // パラメータ：なし

            await axios.post('/api/notification-data/create-notification-data')
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // チェック結果一覧取得API
        async getResults({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // back側からチェック結果データを取得
            // 通信：get
            // パス：/api/notification-data/results
            // パラメータ：ページ番号
            //             １ページあたりの行数
            //             ソートキー
            //             ソート順
            //             フィルタ情報
            await axios.get('/api/notification-data/results', {
                params: {
                    page: data.page,
                    itemsPerPage: data.itemsPerPage,
                    sortKey : data.sortKey,
                    sortOrder : data.sortOrder,
                    filterParams : data.filterParams
                }
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 通知データ作成チェック結果一覧のExcelファイル出力API
        async outputExcelFile({ state, commit, rootState }: any, data: any) {
            // ファイル名の格納
            const fileName = SystemConst.NOTIFICATION_DATA_LIST_EXCEL_FILE_NAME;

            // resultの初期化
            let result: any;

            // URL:GET /api/notification-data/excel-output
            // パラメータ：sortKey
            //             sortOrder
            //             filterParams
            await axios.get('/api/notification-data/excel-output',
            {
                params: {
                    sortKey: data.sortKey,
                    sortOrder: data.sortOrder,
                    filterParams: data.filterParams,
                },
                // レスポンスのバイナリデータをarraybufferで受け取る
                responseType: 'arraybuffer'
            })
            .then((response) => {
                // 通信結果を設定（正常）
                result = response;

                // レスポンス結果のバイナリデータが存在する場合、ファイルを作成する
                if (response.data) {
                    // レスポンス結果のバイナリデータをBlobオブジェクトにする
                    const blob = new Blob([response.data]);

                    // BlobオブジェクトのURLオブジェクトを作成する
                    const objURL: string = window.URL.createObjectURL(blob);

                    // エレメントを作成し、要素にURLオブジェクトとダウンロードするファイル名を格納する
                    const dlLink: HTMLAnchorElement = document.createElement('a');
                    dlLink.href = objURL;
                    dlLink.download = fileName;

                    // 親のHTMLのbody要素に子ノードを追加し、作成した要素を追加する
                    document.body.appendChild(dlLink);

                    // 追加した子ノードの要素に対してクリックイベントを起こし、ファイルをダウンロードする
                    dlLink.click();

                    // 子ノードを削除する
                    document.body.removeChild(dlLink);
                }
            })
            .catch((error) => {
                // 通信結果を設定（エラー）
                result = error.response;

                // ArrayBuffer型のエラーメッセージデータを16進数の文字コードの配列に変換する
                const errorMessage = Array.from(new Uint8Array(error.response.data));

                // 作成した文字コードを文字列に変換し、JSON形式に変換する
                result.data =  JSON.parse(String.fromCharCode.apply('', errorMessage));
            });

            // 通信結果を返す
            return result;
        },

        // ファイルサイズ情報取得API
        async getUseImportantInformationFileSize() {
            // resultの初期化
            let result: any;

            // 重要情報のお知らせに使用するファイルの、ファイルサイズ情報を取得する
            // URL:GET /api/notification-data/get-file-size
            // params: なし
            await axios.get('/api/notification-data/get-file-size')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // ファイルダウンロードAPI
        async useImportantInformationFileDownload({ state, commit, rootState }: any, data: any) {
            // ファイル名の格納
            const fileName = SystemConst.NOTIFICATION_DATA_FILE_NAME[data.getFileParameter]

            // resultの初期化
            let result: any;

            // URL:GET /api/notification-data/file-download
            // パラメータ：getFileParameter: 取得対象ファイルパラメータ（基本データファイル: BASIC, 添付データファイル: ATTACHMENT）
            await axios.get('/api/notification-data/file-download',
            {
                params: {
                    getFileParameter: data.getFileParameter
                },
                // レスポンスのバイナリデータをarraybufferで受け取る
                responseType: 'arraybuffer'
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;

                    // レスポンス結果のバイナリデータが存在する場合、ファイルを作成する
                    if (response.data) {
                        // レスポンス結果のバイナリデータをBlobオブジェクトにする
                        const blob = new Blob([response.data]);

                        // BlobオブジェクトのURLオブジェクトを作成する
                        const objURL: string = window.URL.createObjectURL(blob);

                        // エレメントを作成し、要素にURLオブジェクトとダウンロードするファイル名を格納する
                        const dlLink: HTMLAnchorElement = document.createElement('a');
                        dlLink.href = objURL;
                        dlLink.download = fileName;

                        // 親のHTMLのbody要素に子ノードを追加し、作成した要素を追加する
                        document.body.appendChild(dlLink);

                        // 追加した子ノードの要素に対してクリックイベントを起こし、ファイルをダウンロードする
                        dlLink.click();

                        // 子ノードを削除する
                        document.body.removeChild(dlLink);
                    }
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                    // ArrayBuffer型のエラーメッセージデータを16進数の文字コードの配列に変換する
                    const errorMessage = Array.from(new Uint8Array(error.response.data));

                    // 作成した文字コードを文字列に変換し、JSON形式に変換する
                    result.data =  JSON.parse(String.fromCharCode.apply('', errorMessage));
                });

            // 通信結果を返す
            return result;
        }
    }
}
